import { useLayoutEffect, useRef, useState } from 'react';
import { CAPTION_FONT_SIZE } from './constants';

// Sized and spaced relative to the caption text, like the info panel's icon is
// to its label. The gap is padded either side so the funnel is not jammed
// against the bracket or the colon.
const ICON_SIZE = 0.85 * CAPTION_FONT_SIZE;
// The funnel's box is 24 units; put its middle on the middle of the digits
// rather than on the baseline it would otherwise sit on.
const ICON_VIEWBOX_SIZE = 24;
const ICON_RISE = 0.32 * CAPTION_FONT_SIZE;

// The "filtered" line under a caption: the same funnel as the filter menu
// button, then the counts left in by the filter, e.g. "(<funnel>: 20 voyagers)".
//
// An svg <text> cannot contain a shape, so the funnel is drawn beside the text
// and the room for it is a dx gap between the "(" and the ":". Where that gap
// ends up depends on the width of the text and on it being centred, which only
// the browser knows - hence measuring after layout rather than laying the line
// out by hand. The two char position calls give the edges of the gap and the
// baseline the funnel should sit on.
const FilteredCaption = ({ text, dy }) => {

  const text_ref = useRef(null);
  const [icon_centre, set_icon_centre] = useState(null);

  useLayoutEffect(() => {
    // Char 0 is the "(" and char 1 the ":", so the gap is between the two.
    const gap_start = text_ref.current.getEndPositionOfChar(0);
    const gap_end = text_ref.current.getStartPositionOfChar(1);
    set_icon_centre({ x: (gap_start.x + gap_end.x) / 2, y: gap_start.y - ICON_RISE });
  }, [text, dy]);

  return (
    <>
      <text ref={text_ref} dy={dy}>
        {"("}
        <tspan dx={ICON_SIZE}>{`: ${text})`}</tspan>
      </text>
      {icon_centre &&
        <g transform={`translate(${icon_centre.x - ICON_SIZE / 2}, ${icon_centre.y - ICON_SIZE / 2})`
                      + ` scale(${ICON_SIZE / ICON_VIEWBOX_SIZE})`}
           fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
           pointerEvents="none">
          <polygon points="4 4 20 4 14 12 14 19 10 21 10 12 4 4" />
        </g>
      }
    </>
  );
};

export default FilteredCaption;
